// Возвращает массив лет с 2021 до текущий год + 4 года после текущего
// ex: current year === 2023 -> [2021, 2022, 2023, 2024, 2025, 2026, 2027]
const currentYear = new Date().getFullYear();
const firstYear = 2021;
const countOfYears = currentYear + 5 - firstYear;

export const YEARS = Array.from(Array(countOfYears).keys(), x => {
  return {
    label: (firstYear + x).toString(),
    value: (firstYear + x).toString(),
  };
});
